export default __webpack_public_path__ + "static/covid-press-The New Indian Express-6770548d88dc8a01f46d6fc9d7a20934.png";